import arrow from "../../../image/right.svg";
import arrowWhite from "../../../image/arrowWhite.svg";

export const defaultFilter = {
  age: {
    container: {
      backgroundColor: "#f5f0e7"
    },
    text: {
      color: "#171717"
    },
    arrowImg: arrow
  },
  lesson: {
    container: {
      backgroundColor: "#f5f0e7"
    },
    text: {
      color: "#171717"
    },
    arrowImg: arrow
  },
  important: {
    container: {
      backgroundColor: "#f5f0e7"
    },
    text: {
      color: "#171717"
    },
    arrowImg: arrow
  }
};

export const usedFilterdef = {
  container: {
    backgroundColor: "#f5f0e7"
  },
  text: {
    color: "#171717"
  },
  arrowImg: arrow
};

export const usedFilter = {
  container: {
    backgroundColor: "#EE7A45"
  },
  text: {
    color: "#FFFFFF"
  },
  arrowImg: arrowWhite
};

export const defaultFilterMobile = {
  age: {
    container: {},
    text: {},
    arrowImg: arrow
  },
  lesson: {
    container: {},
    text: {},
    arrowImg: arrow
  },
  important: {
    container: {},
    text: {},
    arrowImg: arrow
  }
};
